document.addEventListener('DOMContentLoaded', () => {
  const tabLinks = document.querySelectorAll('.tab-button');
  const tabPanels = document.querySelectorAll('.tab-panel');

  tabLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      // Deactivate all tabs
      tabLinks.forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      }); 

      // Hide all panels
      tabPanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      // Activate the clicked tab
      link.classList.add('is-active');
      link.setAttribute('aria-selected', 'true');

      // Show matching panel
      const targetID = link.dataset.tabTarget;
      const targetPanel = document.getElementById(targetID);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        targetPanel.setAttribute('aria-hidden', 'false');
      }
    });
  });
});
